import React from 'react';

import PropTypes from 'prop-types';

import {
    FeaturesNew as Features,
    TooltipController,
    TooltipSelect,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './FeaturesDropdown.scss';

const FEATURES_IN_SELECT = 3;

const propTypes = {
    className: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClickFeatures: PropTypes.func,
    onHoverFeatures: PropTypes.func,
    t: PropTypes.func.isRequired,
};

/**
 * @param {number} count - any number
 * @return {(number|null)}
 * @description checks if provided is a positive number and returns that number or null
 */
function additionalAmount(count) {
    return !Number.isNaN(count) && count > 0
        ? count
        : null;
}

function FeaturesDropdown(props) {
    const {
        className = '',
        features,
        onClickFeatures,
        onHoverFeatures,
        t,
    } = props;

    const additionalFeatureCount = features.length - FEATURES_IN_SELECT;

    return (
        <div className={className}>
            <TooltipController
                contentClassName={styles.tooltipContent}
                onClick={onClickFeatures}
                onHover={onHoverFeatures}
                placement="bottom"
            >
                <div>
                    <div className={styles.featuresHeading}>{t('amenities')}</div>
                    <Features
                        featureChipClassName={styles.featureChip}
                        features={features}
                        useChip
                    />
                </div>

                <TooltipSelect className={styles.features}>
                    <Features features={features.slice(0, FEATURES_IN_SELECT)} />
                    <span className={styles.seeMore}>
                        {t('see-more-features', { featuresCount: additionalAmount(additionalFeatureCount) })}
                    </span>
                </TooltipSelect>
            </TooltipController>
        </div>
    );
}

FeaturesDropdown.propTypes = propTypes;

export {
    FEATURES_IN_SELECT,
    FeaturesDropdown,
    additionalAmount,
};
export default localize(FeaturesDropdown, ['t'], 'baseApp');
